import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent {

  constructor(
    private modalRef: NgbActiveModal,
    ) { }

  @Input() public imageSrc:any;  

  close(){
    this.modalRef.close();
  }


}
